/**
 * Created by mateimisarca on 29/11/2019
 */

import VerifyAccount from './VerifyAccount';

export default VerifyAccount;
